import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const customerServiceLiveConversationsRoute: InvariantJiraRoute = {
	name: 'customer-service-live-conversations',
	path: '/jira/servicedesk/projects/:projectKey/conversations/:issueKey?',
	exact: true,
};
